import { ApiState, AuthOut, AuthType, apiBase, ActionCallback, TApiOut, ApiOut } from '../api';
import { LanguageType } from '../config/misc';
import { signUpOptions } from '../config/user';

export class authApi extends apiBase {
	public static errorHandler: ActionCallback<string>;

	private static post<TOut>(u: boolean, n: string, token: string, authType: AuthType, i: any) {
		apiBase.state.bearer = token;
		apiBase.state.bearerType = authType;
		return new Promise<TOut>((res, rej) => {
			apiBase.postData<TOut>((u ? 'user/' : 'usercall/') + n, (r) => {
				if (r.error != null) {
					if (authApi.errorHandler)
						authApi.errorHandler(r.error);
					rej(r.error);
				} else {
					res(r.d);
				}
			}, i, null, false);
		});
	}
	public static verifyEmail = (token: string, authType: AuthType, email: string, lang: LanguageType) => {
		if (authType == AuthType.Email)
			token = ApiState.emailAuthToken;
		else
			email = null;
		return authApi.post<string>(true, "verifyEmail", token, authType, {
			email: email,
			lang: lang
		});
	}
	public static signUp = (token: string, authType: AuthType, options: signUpOptions) => {
		if (authType == AuthType.Email)
			token = ApiState.emailAuthToken;
		return authApi.post<AuthOut>(true, "signUp", token, authType, options);
	}

	public static externalSignIn = (token: string, authType: AuthType) => authApi.post<AuthOut>(true, "signIn", token, authType, {});

	public static signIn = (login: string, pwd: string) => authApi.post<AuthOut>(true, "signIn", ApiState.emailAuthToken, AuthType.Email, {
		login: login,
		pwd: pwd
	});

	public static applyForExtraMonth = (id: string) =>
		authApi.post<ApiOut>(false, "extramonth", apiBase.state.bearer, apiBase.state.bearerType, id);
}
